export const templateKeys = {
  all: ['dataHub', 'templates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  list: (filters: { type: string }) => [...templateKeys.lists(), filters] as const,
  details: () => [...templateKeys.all, 'detail'] as const,
  detail: (id: 'powerQuery' | 'python') => [...templateKeys.details(), id] as const
};
